import { IBundleProductPrice } from "./types";

export default class BundleProductPrice implements IBundleProductPrice {

  id: number;
  price: number;
  type: string;

  constructor(
    id: number,
    price: number,
    type: string
  ) {
    this.id = id;
    this.price = price;
    this.type = type;
  }

}
